import React, {useCallback, useState} from "react";
import {RqInputPerson} from "../../api/dto/RqInputPerson";
import {InputComponent} from "../../components/common/input/InputComponent";
import {RsPerson} from "../../api/dto/RsVerification";
import {ButtonComponent} from "../../components/common/button/ButtonComponent";

export const PersonalInformationViewModel = (onNextClick: () => void) => {

    const [firstName, setFirstName] = useState("")
    const [middleName, setMiddleName] = useState("")
    const [lastName, setLastName] = useState("")
    const [birthDate, setBirthDate] = useState("")
    const [personEditedInformation] =
        useState<RqInputPerson>(RqInputPerson.empty())

    const populatePersonInformation = useCallback((person: RsPerson) => {
        setFirstName(person.firstName)
        setMiddleName(person.middleName)
        setLastName(person.lastName)
        if (person.birthDate) {
            setBirthDate(new Date(person.birthDate).toLocaleDateString("en-GB"))
        }
    }, [])

    const markAsEditedPersonInfo = (field: string, func: (value: string) => void, value: string) => {
        switch (field) {
            case "firstName":
                personEditedInformation.firstName = value
                break
            case "middleName":
                personEditedInformation.middleName = value
                break
            case "lastName":
                personEditedInformation.lastName = value
                break
            case "birthDate":
                personEditedInformation.birthDate = value
                break
        }
        func(value)
    }

    const isEnabled = !!firstName && !!lastName && !!birthDate && birthDate.length === 10

    const buildPersonalInfoBlock = (show: boolean) => (
        <div className={`info-position ${show ? '' : 'hide-important'}`}>
            <div className={`info-container ${show ? '' : 'hide-important'}`}>
                <div className="info-container-title primary-color font-lg full-row">Personal
                    information
                </div>
                <InputComponent
                    label="First name"
                    value={firstName}
                    onChange={(value) => markAsEditedPersonInfo("firstName", setFirstName, value)}/>
                <InputComponent
                    label="Middle name (Optional)"
                    value={middleName}
                    onChange={(value) => markAsEditedPersonInfo("middleName", setMiddleName, value)}/>
                <InputComponent
                    label="Last name"
                    value={lastName}
                    onChange={(value) => markAsEditedPersonInfo("lastName", setLastName, value)}/>
                <InputComponent
                    label="Date of birth"
                    type="date"
                    value={birthDate}
                    placeholder="DD/MM/YYYY"
                    onChange={(value) => markAsEditedPersonInfo("birthDate", setBirthDate, value)}/>

            </div>
            <div className={`width-full info-step-button-container`}>
                <ButtonComponent label="Next" onButtonClick={() => onNextClick()} className={`info-step-button`}
                                 disabled={!isEnabled}/>
            </div>

        </div>

    )

    const personalInformationFieldsAsObject = (): RqInputPerson => {
        return new RqInputPerson(
            firstName,
            middleName,
            lastName,
            birthDate
        )
    }

    return {
        personalInformationFieldsAsObject,
        personEditedInformation,
        buildPersonalInfoBlock,
        populatePersonInformation,
    }

}